import getApiClient from '@/plugins/api-client'

export default {
    load() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('banners')
            .then(result => {
                self.banners = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
    },

    showDeleteConfirmation(id) {
        this.deleteBanner = id

        this.showDeleteConfirmationModal = true
    },

    deleteModal() {
        const self = this,
            api = getApiClient(self.$store),
            id = self.deleteBanner

        api.delete(`banners/${id}`)
            .then(() => {
                self.deleteBanner = null
                let banner = self.banners.filter(banner => {
                    return banner.id === id
                })

                self.load()
                self.showDeleteConfirmationModal = false
            })
            .catch(error => {
                console.log(error)
            })
    },

    cancelDeleteModal() {
        this.deleteBanner = null
        this.showDeleteConfirmationModal = false
    },

    goToEdit(id) {
        this.$router.push(`/banners/edit/${id}`)
    }
}
